import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import dataTool from 'echarts/extension/dataTool';
import * as echarts from 'echarts';
// import { selectUserById } from '@/api';
import App from './App.vue';
import router from './router/router';
import store from './store/store';
import './registerServiceWorker';
import 'font-awesome/css/font-awesome.css';
import './styles/style.scss';

// import { getUserByToken } from '@/api'
// 挂载接口配置表
// import index from "./api/index";
// Vue.prototype._apis = index;

Vue.prototype.$echarts = echarts;
Vue.prototype.$dataTool = dataTool;
Vue.prototype.$baseImageUrl = '/temporary/';
Vue.config.productionTip = false;
Vue.use(ElementUI);
// 设置语言
locale.use(lang);
Vue.prototype.baseUrl = `http://${document.domain}:${location.port}`;
if (localStorage.getItem('access_token')) {
  store.commit('setToken', localStorage.getItem('access_token'));
}
// getUserByToken().then((res) => {
//   console.log(res)
//   // this.islogin = true
//   // this.username = res.data.userName
//   store.commit('setUserInfo',res.data)
//   store.commit('setLoginFlag',true)
// //        if(res.data.userType = '8') {
// //          this.isAdmin = true
// //        } else {
// //          this.isAdmin = false
// //        }
// })


new Vue({
  router,
  store,
  render: h => h(App),
  // created() {
  //   // 举例获取名为"id"的GET参数
  //   const id = getGetParams('aid');
  //   console.log('GET参数id的值为：', id);
  // }
}).$mount('#app');
